import { useState } from "react";
import type { FormEvent } from "react";
import { Modal } from "./ui/Modal";
import { Button } from "./ui/Button";
import { useAuth } from "@/hooks/AuthContext";

interface LoginModalProps {
  open: boolean;
  onClose: () => void;
}

export function LoginModal({ open, onClose }: LoginModalProps) {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login(password);
      setPassword("");
      onClose();
    } catch {
      setError("Incorrect password");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} width="sm">
      <form onSubmit={handleSubmit} className="p-6">
        <h2 className="text-lg font-semibold">Admin sign in</h2>
        <p className="mt-1 text-sm text-muted dark:text-muted-dark">
          Sign in to add, edit, or import events.
        </p>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="mt-4 w-full rounded-lg border border-line dark:border-line-dark bg-transparent px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent/40"
        />
        {error && <p className="mt-2 text-sm font-medium text-red-600">{error}</p>}
        <div className="mt-5 flex justify-end gap-3">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={submitting || !password}>
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
